<template>
  <!--==================
    component for general settings
    ===============-->

  <div class="col-12 pb-20 pt-20 px-0">
    <div class="guidelines p-20">
      <ul class="pb-3 pt-3">
        <li>Fill all the field.</li>
        <li>Be sure with changes may affect the system flow.</li>
      </ul>
    </div>

    <form id="setting-form" class="col pb-4" autocomplete="off">
      <div class="col pb-6">
        <div class="form-row align-items-center col-md-10 mt-3">
          <span class="col-4">Currency</span>
          <div class="form-group col-3 mt-0">
            <input
              type="text"
              class="form-control form-control-sm"
              placeholder="e.g USSD"
              v-model="form.settings[0].value"
            />
          </div>
          <div class="form-group col-5 mt-0">
            <button
              @click="updateAppSetting(0)"
              type="button"
              class="btn btn-success btn-sm col-4"
              :disabled="$v.form.settings.$each[0].value.$invalid"
            >
              <span>Update</span>
            </button>
          </div>
        </div>
        <div class="form-row align-items-center col-md-10 mt-3">
          <span class="col-4">Currency Symbol</span>
          <div class="form-group col-3 mt-0">
            <input
              type="text"
              class="form-control form-control-sm"
              placeholder="e.g $"
              v-model="form.settings[1].value"
            />
          </div>
          <div class="form-group col-5 mt-0">
            <button
              @click="updateAppSetting(1)"
              type="button"
              class="btn btn-success btn-sm col-4"
              :disabled="$v.form.settings.$each[1].value.$invalid"
            >
              <span>Update</span>
            </button>
          </div>
        </div>
        <div class="form-row align-items-center col-md-10 mt-3">
          <span class="col-4">Percent charge quote</span>
          <div class="form-group col-3 mt-0">
            <input
              type="text"
              class="form-control form-control-sm"
              placeholder="e.g 2"
              v-model="form.settings[2].value"
            />
          </div>
          <div class="form-group col-5 mt-0">
            <button
              @click="updateAppSetting(2)"
              type="button"
              class="btn btn-success btn-sm col-4"
              :disabled="$v.form.settings.$each[2].value.$invalid"
            >
              <span>Update</span>
            </button>
          </div>
        </div>
        <div class="form-row align-items-center col-md-10 mt-3">
          <span class="col-4">Exchange rate</span>
          <div class="form-group col-3 mt-0">
            <input
              type="text"
              class="form-control form-control-sm"
              placeholder="e.g 2300"
              v-model="form.settings[3].value"
            />
          </div>
          <div class="form-group col-5 mt-0">
            <button
              @click="updateAppSetting(3)"
              type="button"
              class="btn btn-success btn-sm col-4"
              :disabled="$v.form.settings.$each[3].value.$invalid"
            >
              <span>Update</span>
            </button>
          </div>
        </div>
        <div class="form-row align-items-center col-md-10 mt-3">
          <span class="col-4">Discount percent for fund</span>
          <div class="form-group col-3 mt-0">
            <input
              type="text"
              class="form-control form-control-sm"
              placeholder="e.g 20"
              v-model="form.settings[4].value"
            />
          </div>
          <div class="form-group col-5 mt-0">
            <button
              @click="updateAppSetting(4)"
              type="button"
              class="btn btn-success btn-sm col-4"
              :disabled="$v.form.settings.$each[4].value.$invalid"
            >
              <span>Update</span>
            </button>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import $ from "jquery";
import { required } from "vuelidate/lib/validators";
import { mapGetters, mapActions } from "vuex";

export default {
  data() {
    return {
      form: {
        settings: [{}, {}, {}, {}, {}],
      },
    };
  },

  computed: {
    ...mapGetters(["settings"]),
  },

  mounted() {
    this.$eventHub.$on("app-mounted", async () => {
      await this.fetchSettings();
      this.form.settings = this.settings;

      this.hideBarLoading();
    });
  },

  validations() {
    return {
      form: {
        settings: {
          $each: {
            value: { required },
          },
        },
      },
    };
  },

  methods: {
    ...mapActions(["hideBarLoading", "showSpinnerLoading", "hideSpinnerLoading", "fetchSettings", "updateSetting"]),

    async updateAppSetting(index) {
      const submitData = this.form.settings[index];
      const { id, name, value } = submitData;
      // console.log(submitData);

      this.showSpinnerLoading();
      await this.updateSetting({ id, setting: { name, value } })
        .then((_res) => {
          this.hideSpinnerLoading();
          $.alert("setting updated successfull");
        })
        .catch((_error) => {
          this.hideSpinnerLoading();
          $.alert("setting submision failed!");
        });
    },
  },
};
</script>
